import { useState } from 'react';
import { NewUserVirification } from '../../new-otp-verification';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import { useNavigate } from 'react-router-dom';
import { getUserDataUpdated } from '../../api';
import { FullPageLoader } from '../../../component/helper';

/**
 * Step components for phone/email update process:
 * - Caution: Displays warning/info messages.
 * - Step1: Confirm current contact info and send OTP.
 * - Step2: Verify OTP for current info.
 * - Step3: Enter new contact info and send OTP.
 * - Step4: Verify OTP for new info.
 * - Step5: Confirm and finalize update.
 */
export function Caution({ text, icon }) {
    return (
        <div className="d-flex flex-column align-items-center border border-danger border-dashed rounded-3 p-4 mx-4 my-5">
            <div className="mb-3">
                <i className={icon} ></i>
            </div>
            <p className="mb-0 fs-7 text-dark fw-semibold text-center" >
                {text}
            </p>
        </div>
    );
}


export const Step1 = ({ error, formData, MobileUpdateOtp, type, token }) => {
    const navigation = useNavigate()
    return (
        <>
            <Caution
                icon={"bi bi-exclamation-triangle-fill text-danger fs-4x"}
                text={`Updating your ${type === "phone" ? 'phone number' : 'email address'} will replace your existing contact information. Make sure the new ${type === "phone" ? 'number' : 'email'} is correct and accessible to receive verification codes.`}
            />

            <h5 className="fw-semibolder fs-4 mb-4 text-center">
                <i className={`bi ${type === "phone" ? 'bi-phone-fill' : 'bi-envelope-fill'} me-2 text-danger`}></i>
                Current {type === "phone" ? 'Phone Number' : 'Email'}
            </h5>
            <p className="text-gray-600 text-center mb-4 fs-6">
                Please confirm your {type === "phone" ? 'mobile number' : 'email'} to receive an OTP for verification. This helps secure your account.
            </p>
            {type === "phone" ? (
                <div className="input-group rounded overflow-hidden">
                    <span
                        className="input-group-text bg-white text-gray-600 border-end fs-6 fw-semibold border-end"
                    >
                        +91
                    </span>
                    <input
                        type="text"
                        className="form-control p-4 rounded-0 fs-6 fw-semibold "
                        placeholder={formData?.currentNumber}
                        maxLength={10}
                        disabled
                    />
                </div>
            ) : (
                <div className="input-group mb-4 rounded overflow-hidden">
                    <input
                        type="text"
                        className="form-control p-4 rounded-0 fs-6 fw-semibold"
                        placeholder={formData?.currentEmail}
                        disabled
                    />
                </div>
            )}

            {error && <div className="text-danger">{error}</div>}
            <button onClick={() => MobileUpdateOtp(formData?.currentNumber, 'login')} className="btn btn-primary w-100 p-4 mt-6 fw-semibolder">
                Send OTP
            </button>
            <div
                onClick={() => navigation(`/customer/update-info?token=${token}`)}
                className="text-dark text-decoration-underline d-inline-block mb-3 text-center w-100 text-center fs-4 fw-semibold mt-4 cursor-pointer"
            >
                ← Previous Step
            </div>
        </>
    );
};
export const Step2 = ({ onNext, onPrevious, formData, type, MobileUpdateOtp }) => {
    const maskedNumber = formData?.currentNumber?.replace(/.(?=.{4})/g, '*');
    const maskedEmail = formData?.currentEmail?.replace(/^(.)(.*)(.@.*)$/, (_, first, middle, domain) => {
        return first + middle.replace(/./g, '*') + domain;
    });
    return (
        <>
            <Caution
                icon={"bi bi-shield-lock-fill text-primary fs-4x"}
                text={
                    <>
                        We've sent a 4-digit verification code to your registered {type === 'phone' ? 'mobile number' : 'email address'}
                        <span className='fw-semibold'> {maskedNumber}</span>.
                        <br />
                        Please enter it below to verify your identity.
                    </>
                }
            />

            <NewUserVirification
                title={`Verify ${type === 'phone' ? 'Phone Number' : 'Email Address'}`}
                returnFunction={onNext}
                mobile={formData?.currentNumber}
                closePOup={onPrevious}
                headerImage={false}
                reSendOtp={() => MobileUpdateOtp(formData?.currentNumber, 'login', "resend")}
                description={`Please enter the OTP sent to your registered ${type === 'phone' ? `mobile number ${maskedNumber}` : `email address ${maskedEmail}`} to verify.`}

            />
        </>
    );
};


export const Step3 = ({ setFormData, MobileUpdateOtp, onPrevious, formData, type, error, userData }) => {
    return (
        <>
            <h5 className="fw-semibolder fs-4 mb-4 text-center ">
                <i className={`bi ${type === "phone" ? 'bi-phone-fill' : 'bi-envelope-fill'} me-2 text-danger`}></i>
                New {type === "phone" ? 'Phone Number' : 'Email'}
            </h5>
            <p className="text-gray-600 text-center mb-4 fs-6 ">
                Please confirm your new {type === "phone" ? 'mobile number' : 'email'} to receive an OTP for verification. This helps secure your account.
            </p>
            <div className="card  border m-4 my-8">
                <div className="card-header bg-light-dark fw-semibolder fs-6 p-0 p-3 " style={{ minHeight: "30px" }}>
                    <div>
                        <i className="bi bi-person-circle me-3 fs-5 text-dark"></i>
                        Account Details
                    </div>
                </div>

                <div className="card-body p-4 fs-7">
                    <div className="mb-2 text-gray-600 fs-7">
                        <span className="fw-semibold text-dark">User Name: </span>
                        <span className=''>{userData?.first_name} {userData.last_name}</span>
                    </div>
                    <div className="mb-2 text-gray-600 fs-7 ">
                        <span className="fw-semibold text-dark">Company Name: </span>
                        <span className='fw-semibold'>{userData?.company_name}</span>

                    </div>
                    <div className="mb-2 text-gray-600 fs-7">
                        <span className="fw-semibold text-dark">Firm Name: </span>
                        <span >{userData?.firm_name}</span>
                    </div>
                    <div className="mb-2 fs-7">
                        <span className="fw-semibold text-dark">Projects :</span>
                        {userData && userData?.project?.map((project) => (
                            <>
                                <span className="badge bg-light-success ms-2 text-success">{project}</span>
                            </>
                        ))}

                    </div>
                </div>

            </div>


            {type === "phone" ? (
                <>
                    <div className="input-group mb-2  rounded overflow-hidden">
                        <span
                            className="input-group-text bg-white text-gray-600 border-end  fs-6 fw-semibold"
                        >
                            +91
                        </span>
                        <input
                            value={formData.newNumber}
                            type="number"
                            className="form-control p-4 rounded-0 fs-6 fw-semibold"
                            placeholder="Enter New Mobile Number"
                            maxLength={10}
                            onChange={(e) =>
                                setFormData((prev) => ({ ...prev, newNumber: e.target.value }))
                            }
                        />
                    </div>
                    {error && <div className='text-danger fs-6 fw-normal'>{error}</div>}
                    <button
                        onClick={() => MobileUpdateOtp(formData?.newNumber, "signup")}
                        className="btn btn-primary w-100 mt-2 p-4 fw-semibold"
                        disabled={formData?.newNumber?.length !== 10}
                    >
                        Send OTP
                    </button>
                </>
            ) : (
                <>
                    <div className="input-group mb-2 rounded overflow-hidden">
                        <input
                            type="text"
                            className="form-control p-4 rounded-0 fs-6 fw-semibold"
                            placeholder="Enter New Email Address"
                            onChange={(e) =>
                                setFormData((prev) => ({ ...prev, newEmail: e.target.value }))
                            }
                        />
                    </div>
                    {error && <div className='text-danger fs-6 fw-normal'>{error}</div>}
                    <button
                        onClick={() => MobileUpdateOtp(formData?.currentNumber, "signup")}
                        className="btn btn-primary w-100 mt-2 p-4 fw-semibold"
                        disabled={!formData?.newEmail.includes('@')}
                    >
                        Send OTP
                    </button>
                </>
            )}


            {/* Back Link */}
            <div
                onClick={() => onPrevious(1)}
                className="text-dark text-decoration-underline d-inline-block mb-3 text-center w-100 text-center fs-4 fw-semibold mt-4 cursor-pointer"
            >
                ← Previous Step
            </div>
        </>
    );
};

export const Step4 = ({ onNext, onPrevious, type, formData, MobileUpdateOtp }) => {

    const maskedNumber = formData?.newNumber?.replace(/.(?=.{4})/g, '*');
    const maskedEmail = formData?.newEmail?.replace(/^(.)(.*)(.@.*)$/, (_, first, middle, domain) => {
        return first + middle.replace(/./g, '*') + domain;
    });

    return (
        <>

            <Caution
                icon={"bi bi-shield-lock-fill text-primary fs-4x"}
                text={
                    <>
                        We've sent a 4-digit verification code to your registered {type === 'phone' ? 'mobile number' : 'email address'}
                        <span className='fw-semibold'> {maskedNumber}</span>.
                        <br />
                        Please enter it below to verify your identity.
                    </>
                }
            />

            <div className="mt-3">
                <NewUserVirification
                    title={`Verify New ${type === 'phone' ? 'Phone Number' : 'Email Address'}`}
                    returnFunction={onNext}
                    mobile={formData?.newNumber}
                    closePOup={onPrevious}
                    headerImage={false}
                    reSendOtp={() => MobileUpdateOtp(formData?.newNumber, 'signup', "resend")}
                    description={`Please enter the OTP sent to your registered ${type === 'phone' ? `mobile number ${maskedNumber}` : `email address ${maskedEmail}`} to verify.`}
                />
            </div>
        </>
    );
};


export const Step5 = ({ token, formData, onPrevious, type }) => {
    const [isConfirmed, setIsConfirmed] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    function handleConfirmed() {
        setLoading(true);
        setError('');
        getUserDataUpdated({
            token: token,
            newPhoneNumber: formData?.newNumber,
        }).then((res) => {
            if (res.code === 1) {
                setIsConfirmed(true)
                // if (window.ReactNativeWebView) {
                //     window.ReactNativeWebView.postMessage(JSON.stringify(data));
                // }
            } else {
                setError(res.message || 'Failed to update contact information');

            }
            setLoading(false);
        }).catch((err) => {
            setError('An error occurred while updating contact information. Please try again later.');
        });

    }


    return (
        <>
            {!isConfirmed ? (
                <>
                    {loading && <FullPageLoader />}
                    <div className="d-flex flex-column align-items-center border border-danger border-dashed rounded-3 p-6 mx-4 my-5">
                        <div className="mb-3">
                            <i className="bi bi-exclamation-triangle-fill text-danger fs-4x" ></i>
                        </div>
                        <h4 className="fw-semibold text-danger text-start mb-3">
                            Alert!
                        </h4>
                        <ul className="text-gray-700 fs-6 ps-3 mb-0">
                            <li className="mb-2">
                                You are about to update your contact information. This action will overwrite your currently registered details.
                            </li>
                            <li className="mb-2">
                                Make sure the new contact method is active and accessible. You will receive a One-Time Password (OTP) for verification.
                            </li>
                            <li>
                                The previous contact information will no longer be used for communication. Proceed only if this change is intentional and necessary.
                            </li>
                        </ul>

                    </div>
                    <p className="text-center text-gray-600 fw-semibold mt-3">
                        Once you confirm, this action cannot be undone.
                    </p>
                    {error && <div className="text-danger text-center mb-4">{error}</div>}
                    <button
                        className="btn btn-primary w-100 p-4 fw-semibolder"
                        onClick={handleConfirmed}
                    >
                        Confirm
                    </button>
                    <div
                        onClick={() => onPrevious(3)}
                        className="text-dark text-decoration-underline d-inline-block mb-3 text-center w-100 text-center fs-4 fw-semibold mt-4 cursor-pointer"
                    >
                        ← Previous Step
                    </div>
                </>
            ) : (
                <>

                    <div className="text-center my-5">
                        <img
                            src={toAbsoluteUrl("/media/images/new-success.png")}
                            alt="Success "
                            className="img-fluid "
                            style={{ maxHeight: "200px", objectFit: 'contain' }}
                        />
                    </div>

                    <h2 className="fw-semibold text-center text-success mb-3">
                        <i className="bi bi-check-square-fill text-success fs-3 me-2"></i>
                        {type === 'phone' ? 'Phone Number' : 'Email Address'} Updated!
                    </h2>


                    <p className="text-center text-gray-600 mb-4 fs-5">
                        Your Information has been successfully verified!
                        <br />
                        Thanks for keeping your contact details up to date — it helps us serve you better.
                    </p>

                    <div className="text-center text-gray-600 mt-4 fs-7 ">
                        You can now safely close this window or continue with your next task.
                    </div>
                </>
            )}
        </>
    );
};



